'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from '#pplx/frontend/aether/components/Button/index.js';
import { Tooltip } from '#pplx/frontend/aether/components/Tooltip/index.js';
import { ComposerContainerContext } from '#pplx/frontend/composer-sdk/ComposerContainerContext.js';
import { useComposerActionIcon } from '#pplx/frontend/composer-sdk/internal/primary-action/useComposerActionIcon.js';
import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
import React, { useContext } from 'react';
import { useIntl } from 'react-intl';
export const SubmitButton = React.memo(function SubmitButton({ label, icon = $icon('arrow-up'), variant = 'primary', tooltipSubtitle, disabled = false, isLoading = false, disabledTooltip, rounded = true, onClick, }) {
    const { $t } = useIntl();
    const { isFramed } = useContext(ComposerContainerContext);
    const actionIcon = useComposerActionIcon(icon, isFramed);
    const submitLabel = label ??
        $t({
            defaultMessage: 'Submit',
            description: 'Aria label for the submit button in the composer input',
            id: 'bfedfc55c6',
        });
    const button = (_jsx(Button, { icon: actionIcon, "aria-label": submitLabel, variant: variant, tooltipSubtitle: tooltipSubtitle, size: "small", disabled: disabled, isLoading: isLoading, rounded: rounded, onClick: disabled || isLoading ? undefined : onClick }));
    return disabled && disabledTooltip ? (_jsx(Tooltip, { content: disabledTooltip, children: _jsx("span", { className: "inline-flex", tabIndex: 0, "aria-label": disabledTooltip, children: button }) })) : (button);
});
//# sourceMappingURL=SubmitButton.js.map